import {
  ErrorAssetProps,
  ErrorProps,
} from '@components/sources/visualizer/mappingScreens/errorsView';
import {
  mappingSupportType,
  mappingType,
  WhActionMappingsValidate,
} from '@components/sources/visualizer/mappingScreens/schemaEditor';
import useStores from '@stores/useStores';
import { set } from 'lodash';
import { useCallback, useRef, useState } from 'react';
import { TAB_NAMES } from '@components/sources/source-view';
import { useHistory } from 'react-router-dom';
import { getModifiedDestinationConfig } from '@components/common/util/util';
import { IDestinationStore } from '@stores/destination';
import { CatchErr, FixMe } from '@utils/types';
import exportResponseError from '@utils/exportResponseError';

export default (parsed: FixMe) => {
  const history = useHistory();

  const { sourceDataStore: source, destinationsListStore, messagesStore } = useStores();

  const [edit, setEdit] = useState(!!parsed?.destinationId);
  const [loading, setLoading] = useState(false);
  const [isValid, setValid] = useState(false);
  const [mappingTypeValue, setMappingTypeValue] = useState(mappingType.calculating);
  const [mappingSupportTypeVal, setMappingSupportTypeVal] = useState(
    parsed.destinationId ? mappingSupportType.calculating : mappingSupportType.updating,
  );
  const dest =
    (parsed.destinationId
      ? destinationsListStore?.destinations?.filter((curr) => curr.id === parsed.destinationId)
      : source?.destinations) || [];
  const [bottomEditButtonVisible, setBottomEditButtonVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [schemaErrors, setSchemaErrors] = useState<Record<string, ErrorAssetProps>>({});
  const childRef = useRef<{ whActionMappingsValidate: WhActionMappingsValidate }>();

  const destination: IDestinationStore = dest[0] || {};

  const onCancel = useCallback(() => {
    setEdit(false);
    setBottomEditButtonVisible(false);
    updateSchemaErrors([]);
    if (parsed.destinationId) {
      history.push(`/sources/${source!.id}?tab=${TAB_NAMES.DESTINATIONS}`);
    } else {
      history.push(`/sources/${source!.id}?tab=${TAB_NAMES.SCHEMA}`);
    }
  }, [setEdit]);

  const updateSchemaErrors = (schemaErrorsList: ErrorProps[]) => {
    schemaErrorsList.forEach((schemaErrorsListItem) => {
      set(schemaErrors, schemaErrorsListItem.type, schemaErrorsListItem.errorAssets);
    });

    setSchemaErrors(schemaErrorsList.length > 0 ? { ...schemaErrors } : {});
  };

  const connectSourceToDestination = async (sqlModelId?: string) => {
    const modifiedConfig = getModifiedDestinationConfig(
      destination!.destinationDefinition,
      destination.config,
      destination!.sources,
    );
    const isConfigUpdated = await destination!.updateConfig(modifiedConfig);
    if (isConfigUpdated) {
      const isConnectionComplete = await destinationsListStore!.createDestinationConnections(
        destination,
        [source!.id],
        undefined,
        sqlModelId,
      );
      return isConnectionComplete;
    }
    return false;
  };

  const onSubmit = useCallback(
    async (mappingSupportTypeValExact: string) => {
      setLoading(true);
      try {
        let sqlModelId;
        if (childRef?.current && !!childRef?.current?.whActionMappingsValidate) {
          const updatedConfig = await childRef?.current?.whActionMappingsValidate(true, true);
          if (updatedConfig.errorMessage) {
            setMessage(updatedConfig.errorMessage);
            return;
          }
          sqlModelId = updatedConfig.sqlModelId;
        }
        if (mappingSupportTypeValExact !== mappingSupportType.updating) {
          const isConnectionComplete = await connectSourceToDestination(sqlModelId);
          if (!isConnectionComplete) {
            setMessage('Connection is not complete');
            return;
          }
        }

        setMappingSupportTypeVal(mappingSupportType.updating);
        setEdit(false);
        setBottomEditButtonVisible(false);
        history.push(`/sources/${source!.id}?tab=${'Schema'}`);
      } catch (err: CatchErr) {
        const errMsg = exportResponseError(err)?.message;
        if (errMsg) {
          messagesStore?.showErrorMessage(errMsg);
        }
      } finally {
        setLoading(false);
      }
    },
    [setEdit, setLoading],
  );

  const handleEditClick = useCallback(() => {
    setEdit(true);
    setMappingSupportTypeVal(mappingSupportType.updating);
    setBottomEditButtonVisible(false);
    updateSchemaErrors([]);
  }, [setEdit]);

  return {
    edit,
    loading,
    setLoading,
    isValid,
    setValid,
    mappingTypeValue,
    setMappingTypeValue,
    mappingSupportTypeVal,
    setMappingSupportTypeVal,
    bottomEditButtonVisible,
    setBottomEditButtonVisible,
    schemaErrors,
    message,
    setMessage,
    destination,
    onCancel,
    onSubmit,
    childRef,
    handleEditClick,
    updateSchemaErrors,
    source,
  };
};
